<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <FormFile
          :data="file"
          :loading="isFormLoading"
          :isNew="!id"
          :language="language"
          @submit="fileSubmitHandle"
          @cancel="$router.push({ name: 'page-media-library' })"
          @delete-file="deleteFile"
          @language-update="language = $event"
        />
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmFileRemoving" confirmText="Удалить" />
  </v-container>
</template>

<script>
import ConfirmationDialog from '@/components/confirmation-dialog'
import FormFile from '@/pages/file/form'
import fileQuery from '@/services/gql/types/Files/queries/file.gql'
import updateFileMutation from '@/services/gql/types/Files/mutations/updateFile.gql'
import uploadFileMutation from '@/services/gql/types/Files/mutations/uploadFile.gql'
import deleteFileMutation from '@/services/gql/types/Files/mutations/deleteFile.gql'
import { contentLocales, contentLocalesValues } from '@/configs/locales'
import { getListWithNewMainLanguage } from '@/utils/locales'

export default {
  name: 'PageFile',
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  components: {
    FormFile,
    ConfirmationDialog
  },
  metaInfo () {
    return {
      title: this.id ? 'Редактировать файл' : 'Создать файл'
    }
  },
  computed: {
    isFormLoading () {
      return (
        this.$apollo.queries.file.loading ||
        this.$async.uploadFile.$pending ||
        this.$async.updateFile.$pending
      )
    }
  },
  data () {
    return {
      language: contentLocales[0].value,
      file: {}
    }
  },
  methods: {
    async deleteFile () {
      try {
        await this.$refs.confirmFileRemoving.open()
        await this.$async.deleteFile.$perform({ id: this.id })
        this.$successMsg('Файл удален')
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(e.graphQLErrors, `Ошибка при удалении файла с ID ${this.id}`)
      } finally {
        await this.$router.push({ name: 'page-media-library' })
      }
    },
    fileSubmitHandle (filePayload) {
      if (this.id) this.updateFile(filePayload)
      else this.uploadFile(filePayload)
    },
    async uploadFile ({ data }) {
      try {
        delete data.translations
        await this.$async.uploadFile.$perform({
          data
        })
        this.$successMsg('Файл создан')
        this.$emit('updated')
        await this.$router.push({ name: 'page-media-library' })
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при создании файла')
      }
    },
    async updateFile ({ data }) {
      try {
        // setTranslation(data, this.language)
        await this.$async.updateFile.$perform(
          {
            id: Number(this.id),
            data
          },
          { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) }
        )
        this.$successMsg('Файл обновлен')
        this.$emit('updated')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при обновлении файла')
      }
    }
  },
  apollo: {
    file: {
      fetchPolicy: 'network-only',
      query: fileQuery,
      skip () {
        return !this.id
      },
      variables () {
        return {
          where: {
            id: Number(this.id)
          }
        }
      },
      context () {
        return { headers: { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) } }
      },
      result (res) {
        if (res.data === undefined) {
          this.$handleApiError(res.error)
          this.$router.push({ name: 'page-media-library' })
        } else {
          this.file = res.data?.file
        }
      }
    }
  },
  async: {
    deleteFile (variables) {
      return this.$apollo.mutate({
        mutation: deleteFileMutation,
        variables
      })
    },
    uploadFile (variables) {
      return this.$apollo.mutate({
        mutation: uploadFileMutation,
        variables
      })
    },
    updateFile (variables, headers) {
      return this.$apollo.mutate({
        mutation: updateFileMutation,
        variables,
        context: {
          headers
        }
      })
    }
  }
}
</script>
